import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/paymentsAndPayoutsPage';
import { openPayouts } from './utils';

export default function* listenOpenPayouts() {
  yield takeEvery(actionTypes.openPayouts.toString(), openPayouts);
}
